var r = function() {
  var e = this, a = e.$createElement, s = e._self._c || a;
  return e.hasLanguages ? s("div", {
    ref: "googleTranslateSelectEl",
    class: e.getClass,
    on: {
      mouseenter: e.handleDropdownShowByHover,
      mouseleave: e.handleDropdownHideByHover
    }
  }, [s("div", {
    class: [e.ns.b("dropdown")]
  }, [s("div", {
    class: [e.ns.be("dropdown", "activator")]
  }, [s("div", {
    class: [e.ns.b("language")]
  }, [s("div", {
    class: [e.ns.b("flag")]
  }, [s("div", {
    class: [e.ns.be("flag", e.selectedLanguageOption.code)]
  })]), e._v(" " + e._s(e.selectedLanguageOption.name) + " ")]), e.showArrow ? s("div", {
    class: [e.ns.b("icon"), e.visible ? e.ns.is("reverse") : ""]
  }, [s("svg", {
    attrs: {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }
  }, [s("path", {
    attrs: {
      fill: "currentColor",
      d: "M831.872 340.864 512 652.672 192.128 340.864a30.592 30.592 0 0 0-42.752 0 29.12 29.12 0 0 0 0 41.6L489.664 714.24a32 32 0 0 0 44.672 0l340.288-331.712a29.12 29.12 0 0 0 0-41.728 30.592 30.592 0 0 0-42.752 0z"
    }
  })])]) : e._e()]), s("transition", {
    attrs: {
      name: "google-translate-select-zoom-in-top"
    }
  }, [s("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: e.visible,
      expression: "visible"
    }],
    class: [e.ns.be("dropdown", "menu"), e.dropdownClassName],
    style: e.dropdownStyle
  }, [s("ul", e._l(e.languages, function(n) {
    return s("li", {
      key: `language-${n.code}`,
      class: [e.ns.be("dropdown", "menu__item"), e.hoveredLanguageCode === n.code ? "hover" : "", e.selectedLanguageCode === n.code ? "selected" : ""],
      attrs: {
        "data-language-code": n.code
      },
      on: {
        click: function() {
          return e.handleTranslate(n.code);
        },
        mouseenter: function(o) {
          return o.stopPropagation(), function() {
            return e.hoveredLanguageCode = n.code;
          }();
        },
        mouseleave: function(o) {
          return o.stopPropagation(), function() {
            return e.hoveredLanguageCode = "";
          }();
        }
      }
    }, [s("div", {
      class: [e.ns.b("language")]
    }, [s("div", {
      class: [e.ns.b("flag")]
    }, [s("div", {
      class: [e.ns.be("flag", n.code)]
    })]), e._v(" " + e._s(n.name) + " ")])]);
  }), 0)])])], 1), s("div", {
    attrs: {
      id: e.GOOGLE_TRANSLATE_ORIGINAL_DOM_ID
    }
  })]) : e._e();
}, t = [];
export {
  r as render,
  t as staticRenderFns
};
//# sourceMappingURL=index5.mjs.map
